import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X, ShoppingBasket } from "lucide-react";

const links = [
  { id: "exploitation", label: "L'Exploitation" },
  { id: "produits", label: "Nos Produits" },
  { id: "engagements", label: "Nos Engagements" },
  { id: "visites", label: "Visites & Dégustations" },
  { id: "trouver", label: "Où nous trouver" },
];

const Navbar = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-sable/85 backdrop-blur-xl border-b border-border shadow-[0_4px_20px_rgba(44,42,40,0.06)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-24">
        <button
          data-testid="logo-home"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 leading-none"
        >
          <span className={`w-14 h-14 rounded-full overflow-hidden shrink-0 border transition-colors ${scrolled ? "border-bordeaux/20 bg-creme" : "border-white/50 bg-creme/95 shadow-md"}`}>
            <img src="/logo512.png" alt="Logo Escarg'Holala" className="w-full h-full object-cover scale-110" />
          </span>
          <span className="flex flex-col items-start">
            <span className={`font-heading text-2xl font-700 tracking-tight transition-colors ${scrolled ? "text-bordeaux" : "text-white"}`}>Escarg'Holala</span>
            <span className={`text-[11px] uppercase tracking-[0.25em] mt-0.5 transition-colors ${scrolled ? "text-mousse" : "text-white/75"}`}>Savourez Savianges</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className={`text-sm font-500 transition-colors ${scrolled ? "text-foreground/80 hover:text-bordeaux" : "text-white/85 hover:text-white"}`}
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-order-cta"
            onClick={() => navigate("/commander")}
            className="rounded-full bg-bordeaux text-white text-sm font-600 px-5 py-2.5 hover:bg-bordeaux-dark transition-all hover:-translate-y-0.5 inline-flex items-center gap-2"
          >
            <ShoppingBasket size={16} /> Commander Noël 2026
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className={`lg:hidden transition-colors ${scrolled ? "text-bordeaux" : "text-white"}`}
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-sable/95 backdrop-blur-xl border-t border-border px-6 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left py-2 text-foreground/80 hover:text-bordeaux font-500"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-nav-order"
            onClick={() => navigate("/commander")}
            className="rounded-full bg-bordeaux text-white font-600 px-5 py-3 mt-2 inline-flex items-center justify-center gap-2"
          >
            <ShoppingBasket size={16} /> Commander Noël 2026
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
